<script>
    export default {
       
        mounted(){
            //document.title = "EL Connect - Terms of Service"; 
            window.location.href = '/';
        },
    }
</script>
